import dayjs from 'dayjs';
import { ifClickHandler } from '@lib/events';
import { SonarRecord } from '@ui/records';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
export const PeriscopeReport = ({ onReportClick, report }) => {
    const handleClick = useMemo(() => ifClickHandler(onReportClick, report), [report, onReportClick]);
    const secondaryInfo = report.lastRunDate ? dayjs(report.lastRunDate).format('L') : undefined;
    return (React.createElement(SonarRecord, { name: report.displayName, onClick: handleClick, secondaryInfo: secondaryInfo, sonarObjectId: report.sonarObjectId, sonarObjectType: SonarObjectType.SalesforceReport }));
};
